import React, { useState } from 'react'
import { motion } from 'framer-motion';
import { EmptyNote } from '../empty-note/empty-note';
import { AddNoteCard } from '../add-note-card/add-note-card';
import { AppointmentNote } from '../appointment-note/appointment-note';
import { PastLessonsFeed } from '../past-lessons-feed/past-lessons-feed';
import { useMaterialsFeed } from '@entities/appointment/api/useMaterialsFeed';
import { itemVariants, listVariants } from '@widgets/appointment/lib/appointment-animation';

export const Notes = ({appointment, appointmentId, isTeacher}) => {
	const [isHiddenEmptyMaterials, setIsHiddenEmptyMaterials] = useState(false);
	const feed = useMaterialsFeed(appointmentId, 'notes');
	const notes = feed.currentLesson?.notes ?? appointment?.notes ?? [];
	
	return (
		<motion.div
			key="materials-mode"
			initial="hidden"
			animate="visible"
			exit={{ opacity: 0, y: -10 }}
			variants={listVariants}
			style={{width: '100%'}}
		>
			{!notes?.length && !isHiddenEmptyMaterials ? (
				<motion.div variants={itemVariants} style={{width: '100%'}}>
					<EmptyNote onClick={() => setIsHiddenEmptyMaterials(true)} />
				</motion.div>
			) : (
				<>
					{AddNoteCard ? (
						<motion.div variants={itemVariants} style={{width: '100%'}}>
							<AddNoteCard appointmentId={appointmentId} startExpanded={isHiddenEmptyMaterials} />
						</motion.div>
					) : (
						""
					)}
					{notes?.map((note, index, notes) => {
						const previousNote = notes[index - 1];
						const previousAuthorId = previousNote?.user_id || previousNote?.user?.id;
						const currentAuthorId = note?.user_id || note?.user?.id;
						const showAuthorInfo = index === 0 || String(previousAuthorId) !== String(currentAuthorId);

						return (
						<motion.div key={`note-${note?.id || note?.created_at}`} variants={itemVariants} style={{width: '100%'}}>
							<AppointmentNote {...{ note, appointmentId, isTeacher, showAuthorInfo }} />
						</motion.div>
						);
					})}
					
				</>
			)}
			<PastLessonsFeed
				pastLessons={feed.pastLessons}
				hasMore={feed.hasMore}
				isFetchingPast={feed.isFetchingPast}
				onLoadMore={feed.loadMore}
				kind="notes"
				appointment={appointment}
				isTeacher={isTeacher}
			/>
		</motion.div>
	)
}
